const mytripsTraveller = require('./mytrips_traveller');
const confirmationTraveller = require('./confirmation_traveller');


function travellerFactory(travelerData) {
    return isMytripsDto(travelerData) ? mytripsTraveller(travelerData) : confirmationTraveller(travelerData);
}

function isMytripsDto(dto) {
    return {}.hasOwnProperty.call(dto, 'travellerType');
}

module.exports = travellerFactory;
